'use strict';
import { cn_roof_opening } from '../model/cn_roof_opening';
import { cn_facing_trimming, CN_FACING_TRIMMING_PLACEMENT_CEILING, CN_FACING_TRIMMING_PLACEMENT_WALL } from '../model/cn_facing_trimming';
//***********************************************************************************
//***********************************************************************************
//**** cn_svg_tool_facing  : Facing Manager
//***********************************************************************************
//***********************************************************************************
import { cn_camera } from './cn_camera';
import { cn_svg_map } from './cn_svg_map';
import { cn_svg_tool_creation } from './cn_svg_tool_creation';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_element } from '../model/cn_element';
import { cn_facing_family } from '../model/cn_facing_family';
import { cn_facing_trimming_handler } from './cn_facing_trimming_handler';
import { cn_bbp_geometry } from '../utils/cn_bbp_geometry';
import { HELPER } from '../utils/cn_wordings';
import { cn_scene } from '../model/cn_scene';
import { cn_polygon_handler } from './cn_polygon_handler';
import { cnx_clone } from '../utils/cn_utilities';
import { cn_space_segment } from '../model/cn_space_segment';
import { cn_space } from '../model/cn_space';
import { cn_contour } from '../model/cn_contour';
import { logger } from '../utils/cn_logger';
import { cn_facing } from '../model/cn_facing';
import { cn_detailed_element_type_input, cn_element_type_input, cn_number_input } from './cn_inputs';
import { cn_facade_lineics } from '../model/cn_facade_lineics';
import { CN_CURRENT_DATE } from '../utils/cn_transaction_manager';
import { cn_wall } from '../model/cn_wall';
import { cn_pastille_facing } from './cn_pastille_facing';
import { cn_opening } from '../model/cn_opening';
import { cn_stairs } from '../model/cn_stairs';
import { CODES_BIM_OUVRAGES } from '../utils/cn_bbp_constants';
import { cn_mouse_event } from './cn_mouse_event';
import { cn_space_selection_handler } from './cn_space_selection_handler';
import { cn_mmm_composition } from '../model/cn_mmm_composition';

/**
 */
export class cn_svg_tool_facing extends cn_svg_tool_creation {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} svg_map
     */
    constructor(svg_map) {
        super(svg_map);
        this.selected_element = null;
        this.mouseover_element = null;
        this.mouseover_storey = null;
        this.mouseover_side = null;
        this.mouseover_facing = null;
        this.mouseover_object = null;
        this.mouseover_siblings = [];
        this.selected_siblings = [];
        this.facing_pastilles = [];
        this._facing_lineic_facing = null;
        this._facing_lineics = [];
        this._facing_lineics_date = 0;

        this._space_selection_handler = null;
        this._initial_selection = null;
    }


    //***********************************************************************************
    /**
     * Open tool
     */
    open_tool() {
        this._close_secondary_modes();
        super.open_tool();
        this._building.update_roofs();
        this.push_instruction_input(HELPER.facing.creation);
    }

    //***********************************************************************************
    /**
     * Close tool
     */
    close_tool() {
        this._close_secondary_modes();
        if (this._scene) this._scene.clear_highlighted_facing();
        super.close_tool();
    }

    highlight_facing(cn_facing) {
        this._scene.highlight_facing(cn_facing);
        this.refresh();
    }

    get_facing_families() {
        if (this._storey) {
            if (this._storey.scene.constructor == cn_scene) {
                if (this._storey.exterior)
                    return cn_facing_family.get_exterior_families();
                return cn_facing_family.get_storey_families();
            }
            return cn_facing_family.get_roof_families();
        }
        return cn_facing_family.get_3d_families();
    }

    facing_list() {
        const input = new cn_element_type_input('Liste des revêtements');
        input.choices = this._map._building.get_facing_types().concat([]);
        input.selection = [0];
        this._map.call('element_type_input', input);
    }

    mmm_list() {
        const input = new cn_element_type_input('Liste des substrats');
        input.choices = this._map._building.get_mmm_compositions().concat([]);
        input.selection = [0];
        this._map.call('element_type_input', input);
    }

    _close_secondary_modes() {

        if (this._facing_trimming_handler) {
            const index = this._handlers.indexOf(this._facing_trimming_handler);
            if (index >= 0) this._handlers.splice(index, 1);
            this._facing_trimming_handler = null;
        }

        if (this._space_selection_handler) {
            const index = this._handlers.indexOf(this._space_selection_handler);
            if (index >= 0) this._handlers.splice(index, 1);
            this._space_selection_handler = null;
        }

        this._select_element(null);
    }

    /**
     * Method to call to initiate the creation of a new facing trimming
     * @param {boolean} on
     */
    start_space_selection(on = true) {
        this._initial_selection = this.selected_element;
        this._close_secondary_modes();
        if (!on) return;

        this._space_selection_handler = new cn_space_selection_handler(this._map);
        this._space_selection_handler.authorized_spaces = this._space_selection_handler.authorized_spaces.filter(sp => !sp.outside);
        this._handlers.push(this._space_selection_handler);
    }


    select_all_spaces() {
        if (this._space_selection_handler) {
            this._space_selection_handler.select_all_spaces();
            this.refresh();
        }
    }

    finalize_group_setting() {
        if (!this._space_selection_handler || this._space_selection_handler.spaces.length == 0)
            return;
        this._ask_space_facings(this._space_selection_handler.spaces);
        this._close_secondary_modes();
    }


    _ask_space_facings(spaces) {

        let input = cn_pastille_facing.generic_detailed_element_type_input(this._map);
        input.label = "Revêtements des pièces";

        let null_facing = new cn_facing(this._map._building);
        null_facing.is_null = true;
        null_facing.name = "Non affecté";

        let null_substrate = new cn_mmm_composition(this._map._building);
        null_substrate.is_null = true;
        null_substrate.name = "Par défaut";

        input.checkbox_label = "";
        input.checkbox_status = false;

        input.selection.push({
            label: "Sols",
            code: "floor",
            element_types: [null_facing,null_substrate]
        });

        input.selection.push({
            label: "Murs",
            code: "wall",
            element_types: [null_facing,null_substrate]
        });

        input.selection.push({
            label: "Plafonds",
            code: "ceiling",
            element_types: [null_facing,null_substrate]
        });

        if (this._initial_selection && this._initial_selection.constructor == cn_space) {
            input.selection[0].element_types[0] = this._initial_selection.facings[0] || null_facing;
            this._initial_selection.space_segments.forEach(sslist => sslist.find(ss => {
                if (ss.facing)
                    input.selection[1].element_types[0] = ss.facing;
                if (ss.substrate)
                    input.selection[1].element_types[1] = ss.substrate;
            }));
            input.selection[2].element_types[0] = this._initial_selection.facings[1] || null_facing;
            input.selection[2].element_types[1] = this._initial_selection.substrates[1] || null_substrate;
        }

        let openings = this._scene.walls.flatMap(w => w.openings).
            filter(op => op.valid && op.wall_interface && (spaces.includes(op.wall_interface.spaces[0]) || spaces.includes(op.wall_interface.spaces[1])));

        if (openings.length)
            openings.forEach(op => this.push_item_set(op, "facings"));

        input.cancel = () => {
            if (openings.length) this._ask_opening_facings(openings, spaces, 0);
        };

        input.callback = () => {
            this.push_transaction('Revêtements groupés');
            for (var niter=0;niter<2;niter++) 
            {
                let key = (niter==0)?"facing":"substrate";
                let keys = key + "s";
                input.selection.filter(sel => sel.element_types[niter] && !sel.element_types[niter].is_null).forEach(sel => {
                    if (sel.code == 'floor' || sel.code == 'ceiling') {
                        let index = (sel.code == 'floor') ? 0 : 1;
                        spaces.forEach(sp => {
                            this.push_item_set(sp, keys);
                            sp[keys][index] = sel.element_types[niter];
                        });
                    }
                    else if (sel.code == 'wall') {
                        spaces.forEach(sp => {
                            sp.space_segments.forEach(ssl => {
                                ssl.forEach(ss => {
                                    this.push_item_set(ss, [key, "upper_facings", "upper_substrates", "upper_heights"]);
                                    ss[key] = sel.element_types[niter];
                                    ss.upper_facings = [];
                                    ss.upper_substrates = [];
                                    ss.upper_heights = [];
                                });
                            });
                        });
                    }
                });
            }
            this.refresh();
            input.cancel();
        };

        this._map.call('detailed_element_type_input', input);
    }

    _ask_opening_facings(openings, spaces, group_index) {
        let facing_groups = cn_opening.get_all_facing_groups();
        if (group_index >= facing_groups.length) return;
        let facing_group = facing_groups[group_index];

        let input = cn_pastille_facing.generic_detailed_element_type_input(this._map);
        input.label = facing_group.label;

        let null_facing = new cn_facing(this._map._building);
        null_facing.is_null = true;
        null_facing.name = "Non affecté";
        input.checkbox_label = "Tous identiques";
        input.checkbox_status = true;

        facing_group.roles.forEach(role => {
            input.selection.push({
                label: role.label,
                code: role.code,
                element_types: [null_facing],
            });
        });

        if (this._initial_selection && this._initial_selection.constructor == cn_space) {
            this._scene.walls.flatMap(w => w.openings).
                filter(op => op.valid && op.wall_interface && op.wall_interface.spaces.includes(this._initial_selection)).forEach(op => {
                    let side = op.wall_interface.spaces.indexOf(this._initial_selection);
                    input.selection.filter(sel => sel.element_types[0] == null_facing).forEach(sel => {
                        if (op.facings[side][sel.code])
                            sel.element_types[0] = op.facings[side][sel.code];
                    });
                });
        }


        input.cancel = () => {
            this._ask_opening_facings(openings, spaces, group_index + 1);
        };

        input.callback = () => {
            input.selection.filter(sel => sel.element_types[0] && !sel.element_types[0].is_null).forEach(sel => {
                openings.forEach(op => {
                    [0, 1].forEach(side => {
                        if (spaces.includes(op.wall_interface.spaces[side])) {
                            op.facings[side][sel.code] = sel.element_types[0];
                        }
                    });
                });
            });
            this.refresh();
            input.cancel();
        };

        this._map.call('detailed_element_type_input', input);
    }

    /**
     * Method to call to initiate the creation of a new facing trimming
     * @param {boolean} on
     */
    new_facing_trimming(on = true) {
        this._close_secondary_modes();

        if (!on) return;

        var obj = this;
        var scene = obj._scene;
        const facing_trimming_handler = cn_polygon_handler.create_rectangle(this, 1);
        this._handlers.push(facing_trimming_handler);
        if (scene)
            facing_trimming_handler.snap_elements = scene.spaces;
        this._facing_trimming_handler = facing_trimming_handler;

        //*** event filter */
        var storey_element_creation = null;
        var initial_point = null;
        var initial_normal = null;
        facing_trimming_handler.allow_creation = mouse_event => {
            if (!mouse_event.camera.is_3d()) return true;
            storey_element_creation = null;
            //*** in 3D, we can create a trimmingonly on walls and slabs. */
            if (mouse_event.impact && mouse_event.impact.storey_element) {
                if (mouse_event.impact.storey_element.element.constructor == cn_space_segment && mouse_event.impact.storey_element.element.wall) {
                    storey_element_creation = mouse_event.impact.storey_element;
                    initial_point = cnx_clone(mouse_event.impact.position);
                    initial_normal = cnx_clone(mouse_event.impact.normal);
                    return true;
                }
                if (mouse_event.impact.storey_element.element.constructor == cn_space) return true;
            }
            logger.log(' cannot create on', mouse_event.impact);
            return false;
        }

        //*** Callback upon creation end */
        facing_trimming_handler.on('end_creation', mouse_event => {
            obj.push_transaction('Création de découpe de revêtement');

            const is_3d = mouse_event.camera.is_3d();
            var creation_scene = (scene) ? scene : facing_trimming_handler.creation_storey.scene;
            var facing_trimming = new cn_facing_trimming(creation_scene);

            if (is_3d && storey_element_creation) {
                const space_segment = storey_element_creation.element;
                creation_scene = storey_element_creation.storey.scene;
                facing_trimming = new cn_facing_trimming(creation_scene.building);
                facing_trimming.wall = space_segment.wall;
                facing_trimming.wall_storey = storey_element_creation.storey;
                facing_trimming.wall_side = space_segment.wall_side;
                facing_trimming.wall_point = cnx_clone((facing_trimming.wall_side == 0) ? facing_trimming.wall.bounds.pmin : facing_trimming.wall.bounds.pmax, storey_element_creation.storey.altitude);

                facing_trimming.wall_normal = initial_normal;
                facing_trimming.placement = CN_FACING_TRIMMING_PLACEMENT_WALL;
                facing_trimming.set_shape_3d(facing_trimming_handler.vertices, storey_element_creation.storey);
                logger.log('shape 3d', facing_trimming.get_shape_3d(facing_trimming_handler.creation_storey));
            } else {
                if (is_3d && mouse_event.impact.normal[2] < 0)
                    facing_trimming.placement = CN_FACING_TRIMMING_PLACEMENT_CEILING;
                facing_trimming.shape = new cn_contour(facing_trimming_handler.vertices, facing_trimming);
            }

            if (is_3d && storey_element_creation) {
                obj.push_item_set(creation_scene.building, 'facing_trimmings', () => {
                    creation_scene.update();
                    creation_scene.update_deep();
                });
                creation_scene.building.facing_trimmings.push(facing_trimming);
            } else {
                obj.push_item_set(creation_scene, 'facing_trimmings', () => {
                    creation_scene.update();
                    creation_scene.update_deep();
                });
                creation_scene.facing_trimmings.push(facing_trimming);

            }
            facing_trimming.update();
            obj.remove_handler(facing_trimming_handler);
            creation_scene.update();
            creation_scene.update_deep();
            creation_scene.storey.update_slabs();
            if (obj._map)
                obj._map.refresh();
            if (obj._view_overlay) {
                obj._view_overlay.refresh();
                obj._view_overlay.refresh_3d();
            }
            obj.call('creation', [facing_trimming]);

            obj._other_storey = facing_trimming_handler.creation_storey;
            obj._initiate_edition([facing_trimming]);
        });
    }

    /**
     *
     * @param {cn_facing} facing
     */
    build_facing_lineics(facing) {
        this._facing_lineic_facing = facing;
        this._facing_lineics_date = 0;
    }

    /**
     * Choose how facings are trimmed depending on ground
     */
    choose_facings_above_ground() {
        const input = new cn_number_input('Découpe des revêtements le long du sol', this._building.facings_above_ground_height, 'm', 2, -100, 100, 'Pas de découpe', !this._building.facings_above_ground);

        const obj = this;
        input.callback = () => {
            obj.push_transaction('Découpe des revêtements le long du sol');
            obj.push_item_set(obj._building, ['facings_above_ground_height', 'facings_above_ground']);
            obj._building.facings_above_ground = !input.checkbox_status;
            if (obj._building.facings_above_ground)
                obj._building.facings_above_ground_height = input.value;

            if (obj._map)
                obj._map.refresh();
            if (obj._view_overlay) {
                obj._view_overlay.refresh();
                obj._view_overlay.refresh_3d();
            }
        }
        this.call('number_input', input);
    }

    //***********************************************************************************
    /**
     * SVG rendering
     * @param {cn_camera} camera
     * @returns {string} svg rendered
     */
    // @ts-ignore
    draw(camera) {
        let html = '';

        //*** Draw facade lineics */
        if (this._view_overlay) {
            if (this._facing_lineics_date == 0 || this._facing_lineics_date < this._view_overlay.get_3d_building().get_update_date()) {
                this._facing_lineics = this._facing_lineic_facing ? cn_facade_lineics.build_for_facing(this._building, this._facing_lineic_facing) : [];
                this._facing_lineics_date = CN_CURRENT_DATE;
            }
            this._facing_lineics.forEach(f => html += f.draw(camera));
        }

        function draw_geometries(obj, extras) {
            obj.geometries.filter(g => g.views.includes('3d')).forEach(g => html += g.draw_svg(camera, extras))
        }

        if (this.selected_element) {
            if (this.selected_object && this.selected_object.geometries[0].constructor == cn_bbp_geometry) {
                if (this.selected_siblings.length)
                    this.selected_siblings.forEach(s => draw_geometries(s, 'outline_3d selected'));
                else
                    draw_geometries(this.selected_object, 'outline_3d selected');
            } else
                html += this.selected_element.draw(camera, ['selected', 'no_children']);
            this.facing_pastilles.forEach(pastille => html += pastille.draw(camera));
        }

        if (this.mouseover_element && (!this.selected_element || this.mouseover_element.ID !== this.selected_element.ID)) {
            if (this.mouseover_object && this.mouseover_object.geometries[0].constructor == cn_bbp_geometry) {
                if (this.mouseover_siblings.length)
                    this.mouseover_siblings.forEach(s => draw_geometries(s, 'outline_3d mouseover'));
                else
                    draw_geometries(this.mouseover_object, 'outline_3d mouseover');
            } else
                html += this.mouseover_element.draw(camera, ['mouseover', 'no_children']);
        }

        if (this._scene && this._scene.facing_trimmings)
            this._scene.facing_trimmings.forEach(ft => {
                html += ft.draw(camera);
            });

        html += super.draw(camera);
        return html;
    }

    _select_element(element) {
        if (this.selected_element == element) return;
        this.selected_element = element;

        this.facing_pastilles = [];
        if (this.selected_element) {
            if (this.selected_element.constructor === cn_wall && this.selected_element.has_facings()) {
                this.selected_element.space_segments.forEach(sp =>
                    this.facing_pastilles.push(new cn_pastille_facing(this._map, sp)));

            } else if (this.selected_element.constructor === cn_space) {
                this.selected_element.space_segments.forEach(sps => {
                    sps.filter(sp => sp.wall && sp.wall.has_facings()).forEach(sp =>
                        this.facing_pastilles.push(new cn_pastille_facing(this._map, sp))
                    );
                });
                if (!this.selected_element.outside) {
                    this.facing_pastilles.push(new cn_pastille_facing(this._map, this.selected_element, 0, 30, this._storey.exterior));
                    if (!this._storey.exterior && this.selected_element.has_roof) {
                        this.facing_pastilles.push(new cn_pastille_facing(this._map, this.selected_element, 1));
                    }
                    if (this.selected_element.is_sub_face(this._storey))
                        this.facing_pastilles.push(new cn_pastille_facing(this._map, this.selected_element, 2));
                }
            } else if (this.selected_element.constructor === cn_opening || this.selected_element.constructor === cn_roof_opening) {
                let nb_facings = this.selected_element.get_facing_groups().length;
                for (let i = 0; i < nb_facings; i++)
                    this.facing_pastilles.push(new cn_pastille_facing(this._map, this.selected_element, i));
                this.facing_pastilles.forEach(fp => fp.on("change", () => {
                    this._select_element(null);
                    this._select_element(element);
                }));
            } else if (this.selected_element.constructor === cn_stairs) {
                let nb_facings = this.selected_element.get_facings_codes().length;
                for (let i = 0; i < nb_facings; i++)
                    this.facing_pastilles.push(new cn_pastille_facing(this._map, this.selected_element, i));
                this.facing_pastilles.forEach(fp => fp.on("change", () => {
                    this._select_element(null);
                    this._select_element(element);
                }));
            } else {
                this.facing_pastilles.push(new cn_pastille_facing(this._map, this.selected_element))
            }
        }
    }

    _select_3d_element(ev) {
        if (this.selected_element == this.mouseover_element &&
            this.selected_storey == this.mouseover_storey &&
            this.selected_side == this.mouseover_side) return;
        this.selected_element = this.mouseover_element;
        if (this.selected_element) {
            this.selected_storey = this.mouseover_storey;
            this.selected_side = this.mouseover_side;
            this.selected_object = this.mouseover_object;
            this.selected_siblings = this.mouseover_siblings;
            this.facing_pastilles = [];
            const pastille = new cn_pastille_facing(this._view_overlay, this.selected_element, this.mouseover_side, 30, this.selected_storey.exterior);
            pastille.world_position = ev.impact.position;
            this.facing_pastilles.push(pastille);
            pastille.on('change', () => {
                this._view_overlay.refresh_3d();
            });
        }
    }

    //***********************************************************************************
    /**
     * click
     * @returns {boolean}
     */
    click(ev) {
        if (this.mouseover_facing) {
            this._terminate_edition();
            this.mouseover_facing.clicked();
            return true;
        }
        if (super.click(ev)) return true;
        this._terminate_edition();
        if (this._scene) {
            this._select_element(this._find_facing_element(ev));
        } else {
            this._select_3d_element(ev);
        }
        return true;
    }

    /**
     * move
     *
     * @param {object} ev
     * @returns {boolean}
     */
    move(ev) {
        this.mouseover_facing = null;
        this.mouseover_element = null;
        this.mouseover_siblings = [];
        this.clear_move();

        this.facing_pastilles.forEach(pastille => {
            pastille.mouseover = pastille.contains(ev.mouse_world, ev.camera);
            if (pastille.mouseover) this.mouseover_facing = pastille;
        });

        if (this.mouseover_facing)
            return true;

        if (super.move(ev)) return true;

        if (this._scene)
            this.mouseover_element = this._find_facing_element(ev);
        else if (ev.camera.is_3d()) {
            if (ev.impact) console.log("impact", ev.impact);
            if (ev.impact &&
                ev.impact.storey_element &&
                ev.impact.storey_element.element &&
                ev.impact.object &&
                ev.impact.object.json_object) {
                if (ev.impact.storey_element.element.constructor == cn_space_segment) {
                    this.mouseover_element = ev.impact.storey_element.element;
                    this.mouseover_side = this.mouseover_element.wall_side;
                    this.mouseover_storey = ev.impact.storey_element.storey;
                    this.mouseover_object = ev.impact.object.json_object;
                    this.mouseover_siblings = this._find_siblings(this.mouseover_element, this.mouseover_storey, this.mouseover_side);
                } else if (ev.impact.storey_element.element.constructor == cn_space) {
                    this.mouseover_element = ev.impact.storey_element.element;
                    this.mouseover_side = (ev.impact.object.json_object.Code_BIM == CODES_BIM_OUVRAGES.facing_facade) ? 2 : 0;
                    this.mouseover_storey = ev.impact.storey_element.storey;
                    this.mouseover_object = ev.impact.object.json_object;
                }
            }
        }
        if (this.mouseover_element)
            return true;

        return false
    }

    /** See what facing bearing element is present under the mouse. */
    _find_facing_element(ev) {
        let elt = null;
        [
            this._scene.find_object_instance,
            this._scene.find_beam,
            this._scene.find_column,
            this._scene.find_opening,
            this._scene.find_niche,
            this._scene.find_stairs,
            this._scene.find_pipe,
            this._scene.find_wall,
            this._scene.find_roof_opening,
        ].forEach(searchFunction => {
            if (!elt && searchFunction) {
                elt = searchFunction.apply(this._scene, [ev.mouse_world, ev.camera.snap_world_distance]);
            }
        });
        // @ts-ignore
        if (elt && elt.constructor == cn_wall && !elt.has_facings()) elt = null;
        if (elt || this._scene.constructor != cn_scene) return elt;
        return this._scene.find_space(ev.mouse_world, ev.camera.snap_world_distance);
    }

    _find_siblings(element, storey, side) {
        return this._view_overlay.get_3d_building().get_3d_objects_filter(o => o.json_object.cnmap_element == element &&
            o.json_object.cnmap_storey == storey &&
            o.json_object.geometries[0].constructor == cn_bbp_geometry).map(o => o.json_object);
    }

    /**
     * grab
     *
     * @param {object} ev
     * @returns {boolean}
     */
    grab(ev) {
        if (super.grab(ev)) return true;
        this._terminate_edition();

        return false;
    }

    drag(ev) {
        if (super.drag(ev)) return true;
        return false;
    }

    create(facing) {
        this.push_transaction('Création d\'un revêtement');
        this.push_item_set(this._building, 'facing_types');
        this._building.facing_types.push(facing);
    }

    delete(facing) {
        const facing_index = this._building.facing_types.findIndex(f => f.ID === facing.ID);
        if (facing_index >= 0) {
            this.push_transaction('Suppression d\'un revêtement');
            this.push_item_set(this._building, 'facing_types');
            if (facing.support === 'wall' || facing.support === 'facade') {
                this._building.storeys.forEach(storey => {
                    storey.scene.walls.flatMap(wall => wall.space_segments).filter(wss => wss.facing && wss.facing.ID === facing.ID).forEach(wss => {
                        this.push_item_set(wss, 'facing');
                        wss.facing = null;
                    })
                });
            } else if (facing.support === 'ceiling' || facing.support === 'floor') {
                this._building.storeys.forEach(storey => {
                    storey.scene.spaces.filter(space => space.facings.some(f => f && f.ID === facing.ID)).forEach(space => {
                        this.push_item_set(space, 'facings');
                        if (space.facings[0] && space.facings[0].ID === facing.ID) {
                            space.facings[0] = null;
                        } else if (space.facings[1] && space.facings[1].ID === facing.ID) {
                            space.facings[1] = null;
                        }
                    })
                });
            } else if (facing.support === 'exterior') {
                if (this._building.exterior.scene.spaces) {
                    this._building.exterior.scene.spaces.filter(space => space.facings[0] && space.facings[0].ID === facing.ID).forEach(space => {
                        this.push_item_set(space, 'facings');
                        space.facings[0] = null;
                    })
                }
            } else if (facing.support === 'exterior') {
                if (this._building.exterior.scene.spaces) {
                    this._building.exterior.scene.spaces.filter(space => space.facings[0] && space.facings[0].ID === facing.ID).forEach(space => {
                        this.push_item_set(space, 'facings');
                        space.facings[0] = null;
                    })
                }
            } else if (facing.support === 'other') {
                this._building.storeys.forEach(st => {
                    [
                        ...st.scene.stairs,
                        ...st.scene.object_instances,
                        ...st.scene.beams,
                        ...st.scene.columns
                    ].filter(elt => elt.facing && elt.facing.ID === facing.ID).forEach(elt => {
                        this.push_item_set(elt, 'facing');
                        elt.facing = null;
                    });
                    st.scene.walls.flatMap(w => w.openings).filter(o => o.facings && o.facings.length && o.facings.some(f => f && f.ID === facing.ID)).forEach(opening => {
                        this.push_item_set(opening, 'facings')
                        opening.facings.forEach(f => {
                            if (f && f.ID === facing.ID) {
                                f = null;
                            }
                        })
                    });
                })

            }
            this._building.facing_trimmings.filter(ft => ft.facing && ft.facing.ID === facing.ID).forEach(ft => {
                this.push_item_set(ft, 'facing');
                ft.facing = null;
            })
            this._building.facing_types.splice(facing_index, 1);
        }
    }

    modify(facing) {
        const facing_index = this._building.facing_types.findIndex(f => f.ID === facing.ID);
        this.push_transaction('Modification d\'un revêtement');
        this.push_item_set(this._building.facing_types[facing_index], ['color', 'texture', 'layers', 'name']);
        Object.assign(this._building.facing_types[facing_index], facing);
    }

    //***********************************************************************************
    //**** Edition elements
    //***********************************************************************************
    /**
     * TODO : derivate in order to allow edition of other element in the process of creation
     * @param {cn_mouse_event} mouse_event
     * @returns {cn_element}
     */
    _find_other_element(mouse_event) {
        if (this._scene && this._scene.constructor == cn_scene)
            return this._scene.find_facing_trimming(mouse_event.mouse_world);
        if (mouse_event.camera.is_3d() &&
            mouse_event.impact &&
            mouse_event.impact.storey_element) {
            if (mouse_event.impact.storey_element.element.constructor == cn_facing_trimming) {
                // @ts-ignore
                this._other_storey = mouse_event.impact.storey_element.storey;
                this._other_object = mouse_event.impact.object.json_object;
                return mouse_event.impact.storey_element.element;
            }
        }
        return null;
    }

    /**
     * TODO : derivate in order to provide an edition handler
     * @param {Array<cn_facing_trimming>} elements
     * @returns {cn_edition_handler}
     */
    _build_edition_handler(elements) {
        this._select_element(null);
        const handler = new cn_facing_trimming_handler(elements, (this._map) ? this._map : this._view_overlay, this._other_storey);
        return handler;
    }


}

